import {
  Button,
  Modal,
  Radio,
  RadioChangeEvent,
  Spin,
  Table,
  message as msg,
  message,
  DatePicker,
  Tooltip,
  InputNumber,
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  ApplicantDetails,
  bulkLink,
  BulkLinkPayload,
  bulkSendReport,
  createLink,
  CreateLinkPayload,
  getSystemDate,
  ReportPayload,
} from 'api/agent';
import {
  BulkStatus,
  CustomerModel,
  FilterPayload,
  getOverdueList,
  OverdueList,
  OverduePagedList,
} from 'api/dashboard';
import { LoadingScreen } from 'common/components';
import { Key, useEffect, useState } from 'react';
import xlsx from 'json-as-xlsx';
import { FileExcelFilled } from '@ant-design/icons';
import moment from 'moment';
const dateFormat = 'DD/MM/YYYY';

let payPagedList: OverduePagedList = {
  noOfRecords: 0,
  data: [],
  currentPageIndex: 1,
  pageSize: 50,
};

let initBulkStatus: BulkStatus[] = [];
let initLoanKey: Key = 0;
type Props = {
  filter: FilterPayload;
  onSubmit: (values: FilterPayload) => Promise<void>;
};
const OverdueListPage = ({ filter }: Props) => {
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedAppKeys, setSelectedAppKeys] = useState<React.Key[]>([]);
  const [_loading, setLoading] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [messages, setMessages] = useState(initBulkStatus);
  const [value, setValue] = useState(1);
  // const [bulkSuccess, setBulkSuccess] = useState(0);
  const [_bulkCount, setBulkCount] = useState(0);
  const [reportDate, setReportDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [selectedLoan, setSelectedLoan] = useState(initLoanKey);

  // const [isSending, setSending] = useState(true);

  const onChange = (e: RadioChangeEvent) => {
    // console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };

  const start = async () => {
    debugger;
    // let oldMessages = { ...messages };
    // oldMessages = initBulkStatus;
    // setMessages(oldMessages);
    // setBulkCount(0);
    let bulkSend: any[] = [];
    if (selectedRowKeys.length > 0 && selectedLoan == 0) bulkSend = selectedRowKeys;
    else if (selectedLoan > 0) bulkSend = [selectedLoan];

    // setBulkLoading(true);
    // setValue(1);
    // setBulkCount(bulkSend.filter((x) => x != undefined).length);
    // setSending(true);
    await getSystemDate().then((sysDate) => {
      if (sysDate) {
        // bulkSend.forEach((x, _i) => {
        //   // setTimeout(() => {
        //   let selectedApp = pagedList.data.filter((p) => p.key == x)[0];
        //   // let lastentry = pagedList.data.filter((l) => l.key == pagedList.data.length - 1)[0];
        //   if (selectedApp != null) {
        //     const bulkStatus: BulkStatus = {
        //       LoanNumber: selectedApp?.LoanNumber,
        //       Message: 'Started Link Creation',
        //       isCompleted: false,
        //     };
        //     let lastList = messages;
        //     lastList.push(bulkStatus);
        //     setMessages(lastList);

        //     sendLink(selectedApp, true, value, sysDate.data).then((res) => {
        //       const a = res;
        //       console.log(a);
        //       const recordToUpdate = lastList.filter(
        //         (m) => m.LoanNumber == selectedApp?.LoanNumber
        //       )[0];
        //       // const isCompletedlist = lastList.filter((l) => l.isSuccess == null).length;
        //       // if (isCompletedlist == 0) {
        //       //   setBulkLoading(true);
        //       //   setSending(false);
        //       // }
        //       if (recordToUpdate != null) {
        //         recordToUpdate.LoanNumber = selectedApp?.LoanNumber;

        //         if (a.data != null) {
        //           recordToUpdate.Message =
        //             'Your request for ' +
        //             recordToUpdate.LoanNumber +
        //             ' has been sent successfully. PaymentRequestId ' +
        //             a.data.paymentRequestId.toString() +
        //             ' ';
        //           recordToUpdate.isSuccess = true;
        //           recordToUpdate.isCompleted = true;
        //           // const currSCount = bulkSuccess;
        //           // setBulkSuccess(currSCount + 1);
        //           // if (i == selectedRowKeys.length - 1) {
        //           //   setBulkLoading(true);
        //           //   setSending(false);
        //           // }
        //         } else {
        //           recordToUpdate.Message =
        //             a.message != null && a.message != '' ? a.message : a.error;
        //           recordToUpdate.isSuccess = false;
        //           recordToUpdate.isCompleted = false;
        //           // if (i == selectedRowKeys.length - 1) {
        //           //   setBulkLoading(true);
        //           //   setSending(false);
        //           // }
        //         }
        //         lastList = lastList.filter((x) => x.LoanNumber !== selectedApp?.LoanNumber);
        //         lastList.push(recordToUpdate);
        //         setMessages(lastList);
        //         const isCompletedlist = messages.filter((l) => l.isCompleted == false).length;
        //         if (isCompletedlist == 0) {
        //           setBulkLoading(true);
        //           setSending(false);
        //         }
        //       }
        //     });
        //   }
        //   // }, i * 300);
        // });

        let loanList: string[] = [];
        let linkList: CreateLinkPayload[] = [];
        bulkSend.forEach(async (c, i) => {
          let selectedApp = pagedList.data.filter((p) => p.key == c)[0];
          if (selectedApp) {
            selectedApp.customers = selectedApp.customers.filter((cust) =>
              selectedAppKeys.includes(cust.key)
            );
            loanList.push(selectedApp?.LoanNumber);
            await sendLink(selectedApp, true, value, sysDate.data).then(async (res) => {
              debugger;
              linkList.push(res);
              if (bulkSend.length == i + 1) {
                const bulkPayload: BulkLinkPayload = {
                  loanList: loanList,
                  linkList: linkList,
                  applicantType: value,
                  partnerId: Number(sessionStorage.getItem('partnerId')?.toString()),
                };
                bulkLink(bulkPayload)
                  .then((rsp) => {
                    if (rsp.data != null) {
                      debugger;
                      message.success(bulkSend.length + ' Request queued for Processing.');
                    }
                  })
                  .finally(() => {
                    setSelectedRowKeys([]);
                    setReload(!reload);
                  });
              }
            });
          }
        });
      } else {
        message.warning('Invalid System Date.');
      }
    });
  };

  function handleDownload(_e: any) {
    let settings = {
      fileName: 'BulkSendReport', // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
      RTL: false, // Display the columns from right-to-left (the default value is false)
    };
    let data: any[] = [];
    const list: ReportPayload = {
      // userId: Number(sessionStorage.getItem('userId')?.toString()),
      partnerId: Number(sessionStorage.getItem('partnerId')?.toString()),
      reportDate: moment(reportDate).format('YYYY-MM-DD'),
      isExtract: true,
      type: filter.type,
    };
    bulkSendReport(list).then((res) => {
      debugger;
      if (res) {
        data = [
          {
            sheet: 'Sheet 1',
            columns: [
              { label: 'Batch Id', value: 'batchId' },
              { label: 'Loan Number', value: 'loanNumber' },
              { label: 'Message', value: 'message' },
              // { label: 'Link Sent Date', value: 'linkSentDate' },
              { label: 'Initiated Date', value: 'initiatedDate' },
              { label: 'Triggered By', value: 'userName' },
            ],
            content: res.data,
          },
        ];
        xlsx(data, settings);
      }
    });
  }

  const handleOverdueAmtChange = (e: OverdueList, x: any) => {
    debugger;
    const overdueList = { ...pagedList };

    if (x.target == null || x.target.value == '') {
      message.warn('Amount can not be blank.');
      overdueList.data.forEach((o) => {
        if (o.LoanNumber == e.LoanNumber) {
          o.TotalAmount = 0;
        }
      });
      let deselect = [...selectedRowKeys.filter((x) => x != e.key)];
      setSelectedRowKeys(deselect);
      return;
    }
    if (x.target.value == '0') {
      message.warn('Amount can not be zero.');
      overdueList.data.forEach((o) => {
        if (o.LoanNumber == e.LoanNumber) {
          o.TotalAmount = 0;
        }
      });
      let deselect = [...selectedRowKeys.filter((x) => x != e.key)];
      setSelectedRowKeys(deselect);
      return;
    }

    if (x.target != null && x.target.value != '' && x.target.value != '0') {
      const isNumber = /^\d*$/.test(x.target.value);

      if (isNumber) {
        overdueList.data.forEach((o) => {
          if (o.LoanNumber == e.LoanNumber) {
            o.TotalAmount = x.target != null ? x.target.value : o.TotalAmount;
          }
        });
      } else {
        message.warn('Special Characters are not allowed.');
        overdueList.data.forEach((o) => {
          if (o.LoanNumber == e.LoanNumber) {
            o.TotalAmount = 0;
          }
        });
        let deselect = [...selectedRowKeys.filter((x) => x != e.key)];
        setSelectedRowKeys(deselect);
        return;
      }
    }
    setPagedList(overdueList);
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    // if (selectedRowKeys.length < 200) {
    if (filter.type == 1) {
      let newSelection = newSelectedRowKeys;
      let selectedLoan = pagedList.data.filter(
        (s) => s.key == newSelection[0] && s.TotalAmount == 0
      );
      if (selectedLoan.length > 0) {
        message.warn('Amount cannot be zero.');
        return;
      }
    }
    setSelectedRowKeys(newSelectedRowKeys.filter((_x, i) => i < 200));
    // }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record: OverdueList) => ({
      disabled:
        record.LastLinkStatus == 'BULK PROCESSING...' || selectedAppKeys.length != 0 ? true : false, // Column configuration not to be checked
      name: record.LoanNumber,
    }),
  };

  const onAppSelectChange = (newSelectedRowKeys: React.Key[], _x: any) => {
    debugger;

    // if (selectedRowKeys.length < 200) {
    // const selected = [...selectedAppKeys];
    // newSelectedRowKeys.forEach(x => {
    //   if (_x[0] != null && _x[0].loanKey == selectedLoan) {
    //     if (selectedAppKeys.indexOf(x) <= -1) {
    //       selected.push(x);
    //       setSelectedAppKeys(selected);
    //     }
    //   }
    //   else {
    //     if (_x[0])
    //       setSelectedLoan(_x[0]?.loanKey);
    //     setSelectedAppKeys(newSelectedRowKeys);
    //   }
    // })
    // console.log(selectedLoan);
    if (selectedLoan != 0) {
      if (_x.length > 0) {
        setSelectedLoan(_x[0] ? _x[0]?.loanKey : selectedLoan);
        setValue(3);
        setSelectedAppKeys(newSelectedRowKeys);
        // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
      } else if (_x.length == 0) {
        setSelectedLoan(0);
        setValue(1);
        setSelectedAppKeys([]);
        // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
      }
    } else {
      setSelectedLoan(_x[0] ? _x[0]?.loanKey : selectedLoan);
      setValue(3);
      setSelectedAppKeys(newSelectedRowKeys);
      // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    }
  };

  const appRowSelection = {
    selectedAppKeys,
    onChange: (e: any, record: CustomerModel[]) => onAppSelectChange(e, record),
    getCheckboxProps: (record: CustomerModel) => ({
      disabled: selectedRowKeys.indexOf(record.loanKey) > -1 ? true : false, // Column configuration not to be checked
      name: record.CustomerName,
    }),
  };

  const hasSelected = selectedRowKeys.length > 0;

  const isAdmin = sessionStorage.getItem('isAdmin');
  if (isAdmin != 'true') {
    filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  useEffect(() => {
    setIsLoading(false);
    setPagedList(payPagedList);
    setReportDate(moment(new Date()).format('YYYY-MM-DD'));
    setSelectedRowKeys([]);
    setSelectedAppKeys([]);
    setSelectedLoan(0);
    setValue(1);
    let fil = { ...filter };
    fil.pageNo = 1;
    getOverdueList(fil)
      .then((res) => {
        if (res.data.data != null) {
          res.data.data.forEach((element, index) => {
            element.key = index + 1;
            element.customers.forEach((e) => {
              e.key = e.CIFId;
              e.loanKey = index + 1;
            });
          });
        }
        setPagedList(res.data);
        // message.success('Success');
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, [filter, reload]);

  const overdueCols: ColumnsType<OverdueList> = [
    {
      key: 'LoanNumber',
      title: 'Loan Number',
      dataIndex: 'LoanNumber',
      fixed: 'left',
      width: 160,
    },
    Table.EXPAND_COLUMN,
    {
      key: 'EmiSiPiAmt',
      title: 'Overdue Amount',
      dataIndex: 'EmiSiPiAmt',
      width: 160,
    },
    {
      key: 'CurrMonthInst',
      title: 'Current Installment',
      dataIndex: 'CurrMonthInst',
      width: 160,
    },
    {
      key: 'PenalCharge',
      title: 'Penal Charge',
      dataIndex: 'PenalCharge',
      width: 120,
    },
    {
      key: 'BounceCharge',
      title: 'Bounce Charge',
      dataIndex: 'BounceCharge',
      width: 120,
    },
    {
      key: 'TotalAmount',
      title: 'Total Amount',
      dataIndex: 'TotalAmount',
      width: 120,
      render: (_text, record) => {
        return filter.type != null && filter.type == 1 ? (
          <InputNumber
            type="text"
            value={record.TotalAmount}
            className="form-control"
            placeholder={'Customer Name'}
            onBlur={(e) => handleOverdueAmtChange(record, e)}
          />
        ) : (
          record.TotalAmount
        );
      },
    },
    // {
    //   key: 'CustomerName',
    //   title: 'Customer Name',
    //   dataIndex: 'CustomerName',
    // },
    // {
    //   key: 'MobileNumber',
    //   title: 'Mobile Number',
    //   dataIndex: 'MobileNumber',
    // },
    // {
    //   key: 'EmailId',
    //   title: 'Email Id',
    //   dataIndex: 'EmailId',
    // },

    {
      key: 'LastLink',
      title: 'Link Status',
      dataIndex: 'Action',
      width: 140,
      ellipsis: true,
      render: (_text, record) => {
        return (
          <>
            <Tooltip placement="topLeft" title={record.LastLinkStatus}>
              {record.LastLinkStatus}
            </Tooltip>
          </>
        );
      },
    },
    {
      key: 'LastLinkDate',
      title: 'Link Sent Date & Time',
      dataIndex: 'Action',
      width: 200,
      ellipsis: true,
      render: (_text, record) => {
        return (
          <>
            {record.LastLinkCreated != null ? (
              record.LastLinkStatus != 'BULK PROCESSING...' &&
              record.LastLinkStatus != 'Completed' ? (
                <>
                  <Tooltip placement="topLeft" title={record.LastLinkCreated.toString()}>
                    {record.LastLinkCreated.toString()}
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip placement="topLeft" title={record.LastLinkCreated.toString()}>
                    {record.LastLinkCreated.toString()}
                  </Tooltip>
                </>
              )
            ) : (
              ''
            )}
          </>
        );
      },
    },
    // {
    //   key: 'Action',
    //   title: 'Action',
    //   dataIndex: 'Action',
    //   fixed: 'right',
    //   width: 130,
    //   render: (_text, record) => (
    //     <>
    //       <Button className="ant-btn ant-btn-primary" onClick={() => sendLink(record, false, 3)}>
    //         SEND LINK
    //       </Button>
    //     </>
    //   ),
    // },
  ];

  const applicantsCols: ColumnsType<CustomerModel> = [
    {
      key: 'CustomerName',
      title: 'Customer Name',
      dataIndex: 'CustomerName',
    },
    {
      key: 'MobileNumber',
      title: 'Mobile Number',
      dataIndex: 'MobileNumber',
    },
    {
      key: 'EmailId',
      title: 'Email Id',
      dataIndex: 'EmailId',
    },
    {
      key: 'ApplicantType',
      title: 'Relationship',
      dataIndex: 'ApplicantType',
    },
    // {
    //   key: 'Action',
    //   title: 'Action',
    //   dataIndex: 'Action',
    //   render: (_text, record) => (
    //     <>
    //       <Button
    //         className="ant-btn ant-btn-primary"
    //         style={{ float: 'right' }}
    //         onClick={() =>
    //           sendLink(record, false, record.ApplicantType?.toUpperCase() == 'APPLICANT' ? 1 : 2)
    //         }
    //         loading={loading}
    //       >
    //         SEND LINK
    //       </Button>
    //     </>
    //   ),
    // },
  ];

  const bulkCols: ColumnsType<BulkStatus> = [
    {
      key: 'LoanNumber',
      title: 'Loan Number',
      dataIndex: 'loanNumber',
      width: 200,
    },
    {
      key: 'Message',
      title: 'Message',
      dataIndex: 'message',
    },
  ];
  // let payfilter: FilterPayload = {};
  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    setIsLoading(false);
    setReportDate(moment(new Date()).format('YYYY-MM-DD'));
    setSelectedRowKeys([]);
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    // filter.Username = sessionStorage.getItem('user')?.toString();
    filter.SourceApplicationName = filter.SourceApplicationName;
    filter.IsExtract = false;
    filter.pageNo = _pagination.current;
    filter.pageSize = 50;

    getOverdueList(filter)
      .then((res) => {
        if (res.data.data != null) {
          res.data.data.forEach((element, index) => {
            element.key = index + 1;
            element.customers.forEach((e) => {
              e.key = e.CIFId;
              e.loanKey = index + 1;
            });
          });
        }
        setPagedList(res.data);
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const handleLastStatus = () => {
    const list: ReportPayload = {
      userId: Number(sessionStorage.getItem('userId')?.toString()),
      // sourceId: sessionStorage.getItem('sourceId')?.toString(),
      isExtract: false,
    };
    bulkSendReport(list).then((res) => {
      debugger;
      if (res) {
        debugger;
        setBulkLoading(true);
        setMessages(res.data);
      }
    });
  };

  const handleOk = () => {
    setMessages([]);
    // setBulkCount(0);
    setBulkLoading(false);
    // setBulkSuccess(0);
    setSelectedRowKeys([]);

    // setReload(!reload);
  };

  const handleCancel = () => {
    // if (messages.filter((x) => x.isCompleted == false).length == 0) {
    setMessages([]);
    setBulkLoading(false);
    setBulkCount(0);
    // setBulkSuccess(0);
    setSelectedRowKeys([]);
    // setReload(!reload);
    // } else {
    //   message.warn('Please wait till the current batch is completed!');
    // }
  };
  const handleReportDate = (e: any) => {
    debugger;
    setReportDate(e);
  };

  async function sendLink(
    rec: any,
    _isBulk?: boolean,
    appType?: number,
    systemDate?: Date
  ): Promise<any | undefined> {
    debugger;
    const record = pagedList.data.filter((x) => x.LoanNumber == rec.LoanNumber)[0];
    if (record) {
      let recipients: ApplicantDetails[] = [];

      if (rec.customers == null) {
        recipients = [
          {
            key: '',
            loanType: rec.LoanType?.toString(),
            eMISiPiAmount: rec.EmiSiPiAmt?.toString(),
            overdueAmount: rec.EmiSiPiAmt?.toString(),
            totalAmount: rec.TotalAmount?.toString(),
            currentMonthINST: rec.CurrMonthInst?.toString(),
            allowedAmount: rec.AllowedAmount?.toString(),
            loanBranch: rec.LoanBranch?.toString(),
            customerName: rec.CustomerName?.toString(),
            emailId: rec.EmailId?.toString(),
            mobileNumber: rec.MobileNumber?.toString(),
            accountName: rec.ApplicantType?.toString(),
            cIFId: rec.CIFId?.toString(),
          },
        ];
      } else {
        rec.customers.forEach((x: any) => {
          switch (appType) {
            case 1:
              if (x.ApplicantType.toString() == 'Applicant') {
                const applicant: ApplicantDetails = {
                  key: '',
                  loanType: x.LoanType,
                  customerName: x.CustomerName,
                  emailId: x.EmailId,
                  eMISiPiAmount: undefined,
                  overdueAmount: undefined,
                  totalAmount: undefined,
                  currentMonthINST: undefined,
                  allowedAmount: undefined,
                  loanBranch: undefined,
                  accountName: x.ApplicantType,
                  mobileNumber: x.MobileNumber,
                  cIFId: x.CIFId,
                };
                recipients.push(applicant);
              }
              break;
            case 2:
              if (x.ApplicantType.toString() == 'Co-Applicant') {
                const applicant: ApplicantDetails = {
                  key: '',
                  loanType: x.LoanType,
                  customerName: x.CustomerName,
                  emailId: x.EmailId,
                  eMISiPiAmount: undefined,
                  overdueAmount: undefined,
                  totalAmount: undefined,
                  currentMonthINST: undefined,
                  allowedAmount: undefined,
                  loanBranch: undefined,
                  accountName: x.ApplicantType,
                  mobileNumber: x.MobileNumber,
                  cIFId: x.CIFId,
                };
                recipients.push(applicant);
              }
              break;
            default:
              const applicant: ApplicantDetails = {
                key: '',
                loanType: x.LoanType,
                customerName: x.CustomerName,
                emailId: x.EmailId,
                eMISiPiAmount: undefined,
                overdueAmount: undefined,
                totalAmount: undefined,
                currentMonthINST: undefined,
                allowedAmount: undefined,
                loanBranch: undefined,
                accountName: x.ApplicantType,
                mobileNumber: x.MobileNumber,
                cIFId: x.CIFId,
              };
              recipients.push(applicant);
              break;
          }
        });
      }

      let createdlink: CreateLinkPayload = {
        sourceId: sessionStorage.getItem('sourceId')?.toString(),
        amount: record.TotalAmount != null ? Number(record.TotalAmount) : 0,
        loanType: record.LoanType,
        crmSrNo: null,
        laNumber: record.LoanNumber != null ? record.LoanNumber : '',
        token:
          'MDc2NmRmZDItNzliZS00OWFmLTg3ZDYtNzE5YTk2Y2RjMGRiOiQyYSQwNCRzbFkxTXkwZjhiNFliNjVnQnpaYkEuaWtVUUNyYkJYNEE5N1BuQzNGVmRiajVaOGlSSFhscQ==',
        sessionId:
          sessionStorage.getItem('user') != null ? sessionStorage.getItem('user')?.toString() : '',
        userId:
          sessionStorage.getItem('userId') != null ? Number(sessionStorage.getItem('userId')) : 0,
        mode: 'Online',
        requestPurpose: 'Payment',
        paymentPurpose: 'Overdue',
        receipents: recipients,
        customerName: record.CustomerName,
        emailId: record.EmailId,
        mobileNo: record.MobileNumber,
        cif: record.CIFId,
        allowedAmount: record.AllowedAmount.toString(),
        totalAmount: record.TotalAmount.toString(),
        pennantDate: systemDate
          ? moment(new Date(systemDate ? systemDate : '')).format('YYYY-MM-DD hh:mm:ss')
          : undefined,
      };

      let message: any;

      if (_isBulk) {
        // await createLinkBulk(createlink)
        //   .then((x) => {
        //     message = x;
        //   })
        //   .catch((e: any) => {
        //     message = e;
        //   });

        return createdlink;
      } else {
        await createLink(createdlink)
          .then((x) => {
            // if (isBulk) {
            if (x.data?.paymentRequestId > 0) {
              message =
                'Your request for ' +
                record.LoanNumber +
                ' has been sent successfully. PaymentRequestId ' +
                x.data.paymentRequestId.toString() +
                ' ';
              msg.success(message);
            }
            // }
            // setSending(true);
          })
          .catch((e: any) => {
            message = e;
          })
          .finally(() => {
            // setSelectedRowKeys([]);
            setLoading(false);
          });
      }
      return await message;
    } else {
      return '';
    }
  }
  // console.log('pagedList from API', pagedList);

  return (
    <>
      <div>
        <div className="row" style={{ margin: '10px' }}>
          {filter.type != null && filter.type != 2 ? (
            <>
              <div className="col-md-7" style={{ marginTop: '20px' }}>
                <Radio.Group onChange={onChange} value={value}>
                  <Radio value={1}>Applicant</Radio>
                  <Radio value={2}>Co-Applicants</Radio>
                  <Radio value={4}>All Applicants</Radio>
                </Radio.Group>
                <Button
                  type="primary"
                  onClick={start}
                  disabled={!hasSelected || selectedAppKeys.length > 0}
                >
                  BULK SEND
                </Button>
                <span style={{ marginLeft: 8, marginRight: 8 }}>
                  {`Selected ${
                    selectedRowKeys.filter((x) => x !== undefined).length
                  } items out of ${pagedList.noOfRecords}`}
                </span>
              </div>

              <div className="col-md-2">
                <span style={{ fontWeight: 500 }}>Initiated Date: </span>
                <DatePicker
                  format={dateFormat}
                  onChange={(e) => handleReportDate(e)}
                  defaultValue={moment(new Date())}
                ></DatePicker>
              </div>
              <div className="col-md-1">
                <Button
                  type="link"
                  icon={<FileExcelFilled />}
                  style={{ fontSize: '12px', color: 'green', marginTop: '25px' }}
                  onClick={handleDownload}
                  title={'Download Bulk Send Report'}
                ></Button>
              </div>
              <div className="col-md-2">
                <Button
                  type="primary"
                  style={{ float: 'right', marginRight: '10px', marginTop: '22px' }}
                  onClick={handleLastStatus}
                >
                  {'LAST BATCH STATUS'}
                </Button>
              </div>
            </>
          ) : (
            <>{`Total No. of Records:  ${pagedList.noOfRecords}`}</>
          )}
        </div>
        <Spin spinning={!isLoading}>
          {filter.type != 2 ? (
            <Table
              expandable={{
                expandedRowRender: (record) => {
                  return filter.type == 1 ? (
                    <div>
                      <Table<CustomerModel>
                        dataSource={record.customers}
                        columns={applicantsCols}
                        pagination={false}
                        bordered={true}
                        className={'inner-table'}
                        rowClassName={'form-table'}
                        style={{ width: '85%', height: '80%', marginLeft: '100px' }}
                        rowSelection={appRowSelection}
                      ></Table>
                      <Button
                        type="primary"
                        style={{ float: 'right', marginRight: '100px' }}
                        onClick={start}
                        disabled={record.key == selectedLoan ? false : true}
                      >
                        BULK SEND
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <Table<CustomerModel>
                        dataSource={record.customers}
                        columns={applicantsCols}
                        pagination={false}
                        bordered={true}
                        className={'inner-table'}
                        rowClassName={'form-table'}
                        style={{
                          width: '85%',
                          height: '80%',
                          marginLeft: '100px',
                          marginTop: '10px',
                        }}
                      ></Table>
                    </div>
                  );
                },
              }}
              rowSelection={rowSelection}
              columns={overdueCols}
              dataSource={pagedList.data}
              scroll={{ y: 555 }}
              onChange={handleChange}
              rowClassName="unpad"
              pagination={{
                pageSize: 50,
                total: pagedList.noOfRecords,
                current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
              }}
            />
          ) : (
            <Table
              expandable={{
                expandedRowRender: (record) => {
                  return filter.type == 1 ? (
                    <div>
                      <Table<CustomerModel>
                        dataSource={record.customers}
                        columns={applicantsCols}
                        pagination={false}
                        bordered={true}
                        className={'inner-table'}
                        rowClassName={'form-table'}
                        style={{ width: '85%', height: '80%', marginLeft: '100px' }}
                        rowSelection={appRowSelection}
                      ></Table>
                      <Button
                        type="primary"
                        style={{ float: 'right', marginRight: '100px' }}
                        onClick={start}
                        disabled={record.key == selectedLoan ? false : true}
                      >
                        BULK SEND
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <Table<CustomerModel>
                        dataSource={record.customers}
                        columns={applicantsCols}
                        pagination={false}
                        bordered={true}
                        className={'inner-table'}
                        rowClassName={'form-table'}
                        style={{
                          width: '85%',
                          height: '80%',
                          marginLeft: '100px',
                          marginTop: '10px',
                        }}
                      ></Table>
                    </div>
                  );
                },
              }}
              columns={overdueCols}
              dataSource={pagedList.data}
              scroll={{ y: 555 }}
              onChange={handleChange}
              rowClassName="unpad"
              pagination={{
                pageSize: 50,
                total: pagedList.noOfRecords,
                current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
              }}
            />
          )}
        </Spin>

        <Modal
          title={
            'Batch no: ' + messages[0]?.batchId + ' Initiated at: ' + messages[0]?.initiatedDate
          }
          open={bulkLoading}
          onOk={handleOk}
          onCancel={handleCancel}
          width="auto"
          footer={[<div></div>]}
        >
          <div className="">
            <Table
              dataSource={[...messages]}
              columns={bulkCols}
              scroll={{ y: 300 }}
              pagination={false}
            />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default OverdueListPage;
// async function getSystemDate(): Promise<string> {
//
//   return fetch(import.meta.env.VITE_PENNANT_DATE_URL, {

//     method: 'GET',
//     headers: {
//       'Content-type': 'application/json;',
//       'Access-Control-Allow-Origin': '*',
//       Authorization: import.meta.env.VITE_PENNANT_AUTH_KEY,
//       MessageId: 'sD_' + Date.now(),
//       ServiceVersion: '1',
//       SERVICENAME: 'sysDateService',
//       LANGUAGE: 'EN',
//       REQUESTTIME: moment(new Date()).format('YYYY-MM-DD' + 'T' + 'hh:mm:ss'),
//       entityid: 'Avanse',
//     },
//   })
//     .then((response) => response.json())
//     .then((data) => {
//
//       // const reponse: any = data.json();
//       const sysDate = data.appDate;
//       return sysDate;
//     })
//     .catch((err) => {
//       console.log(err.message);
//       return null;
//     });
// }
